import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import DisplayOptions from 'components/DisplayOptions';
import {VisibilityOptions} from 'components/VisibilityOptions';
import AntibodyToolsMetadata from 'molbio/maps/options/AntibodyToolsMetadata';
import OptionsBanner from 'molbio/maps/options/OptionsBanner';
import SearchButton from 'molbio/maps/options/SearchButton';
import {ZoomSlider, ZoomSliderProps} from 'molbio/maps/options/Sliders';
import getTestProps from 'test/lib/cypress/getTestProps';

interface Props {
  aminoAcids: string;
  bannerText?: React.ReactNode;
  onSearch: () => void;
  visibilityOptions: VisibilityOptions;
  zoomSliderProps: ZoomSliderProps;
  featureCounts: {annotations: number};
}

function ProteinMapOptions({
  aminoAcids,
  bannerText,
  onSearch,
  visibilityOptions,
  zoomSliderProps,
  featureCounts,
}: Props): JSX.Element {
  return (
    <div className="reset">
      <div
        className="buffer-options-container"
        {...getTestProps({
          component: 'ProteinMapOptions',
          element: 'root',
        })}
      >
        <BufferOptionsItem>
          <ZoomSlider {...zoomSliderProps} className={css(styles.noShrink)} />
        </BufferOptionsItem>
        <OptionsBanner bannerText={bannerText} />
        <AntibodyToolsMetadata aminoAcids={aminoAcids} visibilityOptions={visibilityOptions} />
        <div className={`buttonGroup ${css(styles.noShrink)}`}>
          <DisplayOptions featureCounts={featureCounts} options={visibilityOptions} />
          <SearchButton onToggleSearch={onSearch} />
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  noShrink: {
    flexShrink: 0,
  },
});

export default ProteinMapOptions;
